/* unplugin-vue-components disabled */
import {TASK_AMDOCS_SCRAPE, TASK_AMDOCS_SCRAPE_DELETE} from 'consts/api'
import {SETTING_AMDOCS_SCAPE_TASK} from 'consts/settings'
import {TASK_STATUS} from 'utils/tasks'
import {Tasks} from 'utils'
import $settings from 'stores/settings'

export default {
  data() {
    return {
      tasks: new Tasks(),
      loading: true,
      task_setting: undefined,
      task_data: undefined,
      show_copy_tip: false
    }
  },
  computed: {
    task_status() {
      if (this.task_data) return this.task_data.status
      if (this.task_setting) return 'No task data found. Probably task was running long ago and is already deleted.'
      return 'Never launched'
    },
    ended() {
      return [TASK_STATUS.COMPLETED, TASK_STATUS.FAILED].includes(this.task_status)
    },
    can_run() {
      return !this.loading && (!this.task_data || this.ended)
    },
    date() {
      return this.task_data ? $utils.format.datetime(this.task_data.created_at) : undefined
    }
  },
  async mounted() {
    this.loading = true
    this.task_setting = await $settings.get(SETTING_AMDOCS_SCAPE_TASK)
    await this.waitTask()
    this.loading = false
  },
  beforeUnmount() {
    this.tasks.cancelAll()
  },
  methods: {
    async waitTask() {
      this.loading = true
      if (this.task_setting) {
        try {
          this.task_data = await this.tasks.get(this.task_setting.id)
          this.task_data = await this.tasks.waitTask(this.task_setting.id)
        }
        catch(err) {
          if (err.http_code === 404) {
            // task might be missing if it was running long ago
            // that's ok, tasks are kept in db only for 1 month
            return
          }
          throw err
        }
      }
      this.loading = false
    },
    async scrape() {
      this.loading = true
      this.task_setting = undefined
      this.task_data = undefined
      this.task_setting = {
        id: await this.tasks.start(TASK_AMDOCS_SCRAPE), 
        type: 'scrape'
      }
      await $settings.put(SETTING_AMDOCS_SCAPE_TASK, this.task_setting)
      await this.waitTask()
      this.loading = false
    },
    async cleanup() {
      this.loading = true
      this.task_setting = undefined
      this.task_data = undefined
      this.task_setting = {
        id: await this.tasks.start(TASK_AMDOCS_SCRAPE_DELETE), 
        type: 'cleanup'
      }
      await $settings.put(SETTING_AMDOCS_SCAPE_TASK, this.task_setting)
      await this.waitTask()
      this.loading = false
    },
    async copyError() {
      await $utils.copyText($utils.format.json(this.task_data.error))
      this.show_copy_tip = true
      await $utils.timers.wait(2000)
      this.show_copy_tip = false
    }
  }
}
